import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  .relative-percentage-div {
    width: 100%;
    height: 50px;
    background: linear-gradient(to right, red 50%, blue 50%);
    position: relative;
  }

  .left-percentage,
  .right-percentage {
    height: 100%;
    position: absolute;
    top: 0;
  }

  .left-percentage {
    background-color: #ff6a00;
    right: 50%;
  }

  .right-percentage {
    background-color: blue;
    left: 50%;
  }
`;
